import { useAPIClient } from "render/context/APIContext";
import { useCallback } from "react";
import { useSession } from "render/context/MSALContext";
import { APITypes } from "@cur8/api-client";

export function useOptOutStudyConsentMutation() {
  const { patientId } = useSession();
  const client = useAPIClient().consent;

  return useCallback(
    (body: Omit<APITypes.SignConsentRequest, "consentSignature">) =>
      client.optOutFromConsentFor({
        patientId,
        body: {
          documentUri: body.documentUri,
          expiresAt: body.expiresAt,
          consentSignature: {
            $type: "login",
          },
        },
      }).result,
    [client, patientId]
  );
}
